/**
 * Configuración default de campaña de módulo
 * Será mergeada con deepmerge con campaña específica
 */
import { countSteps } from "../../utils";
export default {
  googleAnalyticsId: "UA-141672014-1",
  modulo: _BBVA_MODULE_NAME,
  cantPasos: function() {
    return countSteps(Object.values(this.pasos));
  },
  ofertaItems: {
    /**
     * Muchos se repiten entre `cliente` y `noCliente` pero se cambió el orden más de una vez
     * y es más fácil repetirlos acá que armar una mejor lógica
     */
    noCliente: [
      {
        label:
          "<strong>Tarjeta Visa Business</strong> <em>1</em> <strong>LATAM Pass</strong> <em>2</em> bonificada por 12 meses <em>3</em>",
        productName: "visa business",
        productSubtype: "tarjetas credito",
        primaryCategory: "tarjetas"
      },
      {
        label: "<strong>Acuerdo de cuenta corriente.</strong><em>1</em>",
        productName: null,
        productSubtype: null,
        primaryCategory: null
      },
      {
        label: "<strong>Préstamo financiero.</strong><em>1</em>",
        productName: "prestamos financiero",
        productSubtype: "prestamos financiero",
        primaryCategory: "prestamos"
      },
      {
        label:
          "<strong>Ofertas exclusivas para el Descuento de Cheques.</strong><em>1</em>",
        productName: null,
        productSubtype: null,
        primaryCategory: null
      },
      {
        label:
          "y además te llevás <strong>Cuenta Corriente</strong> bonificada por 6 meses.<em>3</em>",
        productName: "cuenta corriente pesos",
        productSubtype: "cuenta corriente",
        primaryCategory: "cuentas"
      }
    ],
    cliente: [
      {
        label:
          "<strong>Tarjeta Visa Business</strong> <em>1</em> <strong>LATAM Pass</strong> <em>2</em>",
        productName: "visa business",
        productSubtype: "tarjetas credito",
        primaryCategory: "tarjetas"
      },
      {
        label: "<strong>Acuerdo de cuenta corriente.</strong><em>1</em>",
        productName: null,
        productSubtype: null,
        primaryCategory: null
      },
      {
        label: "<strong>Préstamo financiero.</strong><em>1</em>",
        productName: "prestamos financiero",
        productSubtype: "prestamos financiero",
        primaryCategory: "prestamos"
      },
      {
        label:
          "<strong>Ofertas exclusivas para el Descuento de Cheques.</strong><em>1</em>",
        productName: null,
        productSubtype: null,
        primaryCategory: null
      }
    ],
    checkItemsLargoPlazo: [
      {
        label:
          "<strong>Financiación para compra de vehículos y maquinarias.</strong><em>1</em>",
        productName: "prestamos leasing",
        productSubtype: "prestamos leasing",
        primaryCategory: "prestamos"
      }
    ]
  },
  pasos: {
    // landing: {
    //   path: "/",
    //   component: "views/Landing",
    //   titulo: "Simulá la mejor financiación para tu empresa",
    //   subtitulo:
    //     "Te ayudamos a encontrar la mejor financiación para tu empresa. Ingresando los siguientes datos, podremos realizar una simulación de límites crediticios para tu empresa."
    // },
    // paso1: {
    //   path: "/paso1",
    //   component: "views/Paso1",
    //   paso: 1,
    //   titulo: "Datos de la empresa o comercio",
    //   subtitulo: "Ingresá los siguientes datos para avanzar en el cálculo.",
    //   legales:
    //     '<h2>Datos personales</h2><p>Los datos personales aquí incluidos tienen el carácter de declaración jurada y son recogidos para ser incorporados y tratados en una base de datos, la cual se encuentra registrada en la Agencia de Acceso a la Información Pública, cuyo destinatario y titular es el Banco BBVA Argentina S.A. Cualquier falseamiento, error y/o inexactitud respecto a la información implicará la supresión de estos datos de la base de referencia y no podrán ser utilizados a futuro.</p><p>El usuario presta su consentimiento expreso al BBVA, para que toda la información referente a su persona, sus actividades económicas o las operaciones que haya concertado o que concierte en el futuro (en adelante y en su conjunto "la información") pueda ser transferida y cedida, aun en forma gratuita, dentro de estrictas políticas de confidencialidad y seguridad de los datos, a sus afiliadas, subsidiarias, controlantes, controladas y/o cualquier tercero. La información podrá ser utilizada para: a) La realización de segmentaciones o perfiles del Cliente, con fines comerciales a efectos de adaptar los productos o servicios a necesidades o características específicas, así como con fines de análisis de riesgos para evaluar nuevas operaciones, en ambos supuestos conservando dichas segmentaciones o perfiles en tanto y en cuanto el interviniente mantenga relación contractual con el BBVA, pudiendo oponerse en cualquier momento a dicho tratamiento; b) El envío a través de cualquier medio, por parte del BBVA de otros terceros, de ofertas comerciales, distintos tipos de informaciones o publicidades, personalizadas o no, sobre productos o servicios propios o de terceros; c) Para cualquier otra finalidad no incompatible con las especificadas anteriormente. Cuando así lo disponga, el usuario tendrá el derecho de acceder a la información y solicitar su rectificación o supresión de la base de archivo.</p><p>El BBVA informa al usuario que sus datos personales podrán ser cedidos a las autoridades competentes cuando las leyes o regulaciones de aplicación así lo establezcan.</p><p>En función del Estándar de la Organización para la Cooperación y Desarrollo Económicos (OCDE) para el Intercambio Automático de Información en Asuntos Fiscales y de las disposiciones de la Ley de cumplimiento fiscal de cuentas extranjeras (“Foreign Account Tax Compliance Act” - FATCA) de los Estados Unidos de América, el cliente autoriza al Banco a ceder información a autoridades de terceros países por operatorias desarrolladas en los mercados internacionales tales como Estados Unidos. Lo expuesto, ya sea de forma agregada o individual, según el caso.</p><p>El titular de los datos personales tiene el derecho de acceso a los mismos en forma gratuita en intervalos no inferiores a seis meses, salvo que se acredite un interés legítimo al efecto conforme lo establecido en el artículo 14, inciso 3 de la Ley 25.326.</p><p>La AGENCIA DE ACCESO A LA INFORMACIÓN PUBLICA, Órgano de Control de la Ley Nº 25.326, tiene la atribución de atender las denuncias y reclamos que se interpongan con relación al incumplimiento de las normas sobre protección de datos personales.</p><h2>Sistemas de Biometría:</h2><p>En caso de que el BBVA defina el uso de dispositivos para la captura, lectura y/o procesamiento de datos –inclusive aquellos de carácter biométricos– en alguno de sus procesos operativos y/o de seguridad aplicables, el usuario autoriza al BBVA a compartir estos datos con terceros exclusivamente para el resguardo de la información capturada, la verificación de la identidad del titular de los datos y/o con los fines que el BBVA determine.</p><h2>Sistemas de información crediticia:</h2><p>Ante la solicitud de cualquier producto, el BBVA puede solicitar información a las agencias de informes comerciales a fin de evaluar la situación crediticia del usuario.</p><p>El usuario acepta que estará sujeto a la clasificación e inclusión en la "Central de deudores del sistema financiero", de conformidad a la normativa vigente del B.C.R.A., dado que es obligación del BBVA informar, solamente, al Banco Central de la República Argentina todos los datos que éste le requiera o que pudiera requerirle en el futuro, relacionados con sus Clientes. No será responsabilidad del BBVA la utilización de la información del usuario por parte de terceros distintos al B.C.R.A., dado que la misma no es proporcionada por el Banco.</p>'
    // },
    // paso2: {
    //   path: "/paso2",
    //   component: "views/Paso2",
    //   paso: 2,
    //   titulo: "Datos del balance de la empresa",
    //   subtitulo: "Ingresá los siguientes datos para avanzar en el cálculo."
    // },
    // paso3: {
    //   path: "/paso3",
    //   component: "views/Paso3",
    //   paso: 3,
    //   legales:
    //     "<h2>Simulación de límites crediticios válida por el día de la fecha. Cartera comercial.</h2><p>(1) El otorgamiento de los productos comprendidos se encuentra sujeto al cumplimiento de los requisitos exigidos por el departamento de créditos de Banco BBVA Argentina S.A. y demás condiciones de vinculación no constituyendo la presente un compromiso en firme por parte del Banco ni responsabilidad alguna en caso de negativa.</p><p>(2) El programa LATAM Pass no es acumulable con otras promociones de suma y acumulación de puntos. Los términos y condiciones de LATAM Pass son de exclusiva propiedad de LATAM. Los mismos se encuentran disponibles en su sitio web www.latam.com.ar y podrán ser modificados. LATAM es responsable por la administración del programa.</p><p>(3) Bonificación válida sólo para Cuentas Visa Business y Cuentas Corrientes de Nuevos Clientes que contraten con el Banco dentro del período de vigencia de la presente, por el día de la fecha y hasta el día 31/03/2020 .Las bonificaciones corresponden al costo de mantenimiento mensual por 12 meses.</p><p>Los accionistas de Banco BBVA Argentina S.A. limitan su responsabilidad a la integración de las acciones suscriptas conforme Ley 19.550 y Ley 25.738. CUIT 30-500000319-3. AV. CÓRDOBA 111, piso 31 CABA - CP 1054.</p>"
    // },
    // paso4: {
    //   path: "/paso4",
    //   component: "views/Paso4",
    //   paso: 4,
    //   nombreSiguiente: "Enviar",
    //   titulo: "Datos de contacto",
    //   subtitulo:
    //     "Ingresá los siguientes datos para enviarte los resultados de la calificación crediticia preaprobada.",
    //   subtituloExceded:
    //     "Ingresá los siguientes datos de contacto para que podamos brindarte asesoramiento de forma personalizada."
    // },
    gracias: {
      path: "/gracias",
      component: "views/Gracias"
    },
    mensaje: {
      path: "/mensaje/:mje",
      component: "views/Mensaje"
    }
  }
};
